import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";

type ErrorDialogProps = {
  onClose: () => void;
};

const ErrorDialog = ({ onClose }: ErrorDialogProps) => {
  const [t] = useTranslation();

  return (
    <>
      <DialogTitle>{t("PDFの表示に失敗しました")}</DialogTitle>
      <DialogContent>
        <DialogContentText style={{ wordBreak: "break-all" }}>
          {t("URLに誤りがないか確認し、読み込み直してください。")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button fullWidth onClick={onClose}>
          {t("閉じる")}
        </Button>
      </DialogActions>
    </>
  );
};

export default memo(ErrorDialog);
